import _ from 'lodash';
import { ACTIONS, CONSTANTS } from '../config/constants';

export function initApp(product) {
  return (dispatch, getState) => {
    return ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
      `${ACTIONS.JSON_API_PATH}/_initApp`,
      {
        headers: {
          Authorization: `Bearer ${
            process.env.REACT_APP_MOBILE_TEST
              ? 'MOBILE_TEST_AUTH'
              : getState().auth.accessToken
          }`
        },
        params: {
          product
        }
      }
    ).then(res => {
      const {
        currentQuiz,
        newFeatures,
        product,
        profs,
        settings,
        user
      } = res.data.data[0].attributes;

      const userProf = profs.splice(
        profs.reduce((i, p, idx) => (p.id === user.ProfessionId ? idx : i), -1),
        1
      )[0];
      profs.unshift(userProf);

      return dispatch({
        type: ACTIONS.TYPES.APP.INIT_SUCCESS,
        app: {
          currentQuiz,
          newFeatures,
          product,
          profs,
          settings,
          user,
          navOpen: false
        }
      });
    });
  };
}

export function changeState(state, params = {}) {
  return dispatch =>
    new Promise(res =>
      res(
        dispatch({
          type: ACTIONS.TYPES.APP.CHANGE_STATE,
          currentState: { state, params }
        })
      )
    );
}

export function updateApp(update) {
  return (dispatch, getState) =>
    new Promise(res => {
      res(
        dispatch({
          type: ACTIONS.TYPES.APP.UPDATE_APP,
          app: Object.assign(_.cloneDeep(getState().app), update)
        })
      );
    });
}

export function toggleNav() {
  return (dispatch, getState) => {
    const app = Object.assign(_.cloneDeep(getState().app), {
      navOpen: !getState().app.navOpen
    });
    dispatch({ type: ACTIONS.TYPES.APP.UPDATE_APP, app });
  };
}

export function fetchDashboardStats(user) {
  return (dispatch, getState) => {
    dispatch({
      type: ACTIONS.TYPES.APP.FETCH_STATS_SUCCESS,
      stats: { loading: true }
    });
    return ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
      `${ACTIONS.JSON_API_PATH}/_dashboard`,
      {
        headers: {
          Authorization: `Bearer ${
            process.env.REACT_APP_MOBILE_TEST
              ? 'MOBILE_TEST_AUTH'
              : getState().auth.accessToken
          }`
        },
        params: { product: getState().app.product }
      }
    ).then(res => {
      const { stats } = res.data.data[0].attributes;

      const userProf = stats.professions.splice(
        stats.professions.reduce(
          (i, p, idx) => (p.id === user.ProfessionId ? idx : i),
          -1
        ),
        1
      )[0];
      stats.professions.unshift(userProf);
      return dispatch({
        type: ACTIONS.TYPES.APP.FETCH_STATS_SUCCESS,
        stats: Object.assign(stats, { loading: false })
      });
    });
  };
}

export function updateDashboardQuestionCount(questionId) {
  return (dispatch, getState) => {
    const state = _.cloneDeep(getState());
    const ids = state.stats.answeredQuestions;

    if (ids && ids.indexOf(questionId) === -1) {
      state.stats.answeredQuestions.push(questionId);
      dispatch({
        type: ACTIONS.TYPES.APP.FETCH_STATS_SUCCESS,
        stats: state.stats
      });
    }
  };
}

export function updateDashboard(isNewQuiz = false) {
  return (dispatch, getState) => {
    const state = getState();
    const stats = _.cloneDeep(state.stats) || {
      quizzes: [],
      progress: [],
      overall: { totalCount: 0, correctCount: 0, time: 0, sessions: 0 }
    };
    const question = state.quiz.questions[state.quiz.currentQuestionIndex];
    const today = new Date().toDateString();

    if (isNewQuiz && stats) {
      if (stats.quizzes[0] && stats.progress[0]) {
        stats.quizzes[1] = Object.assign({}, stats.quizzes[0]);
      }
      Object.assign(stats.quizzes[0] || {}, {
        date: new Date().toDateString(),
        totalCount: 0,
        correctCount: 0,
        time: 0
      });

      if (
        (stats.progress[0] && !stats.progress.length) ||
        (stats.progress[0] && stats.progress[0].date !== today)
      ) {
        stats.progress.unshift({
          date: today,
          totalCount: 0,
          correctCount: 0,
          sessions: 1,
          time: 0
        });
      } else {
        Object.assign(stats.progress[0] || {}, {
          sessions: stats.progress[0] ? stats.progress[0].sessions + 1 : 1
        });
      }

      Object.assign(stats.overall, { sessions: stats.overall.sessions + 1 });
    } else if (question.selectedOptionIndex > -1) {
      const correctResponse =
        question.options[question.selectedOptionIndex].correctOption;

      if (stats && stats.progress[0] && stats.progress[0].date !== today) {
        stats.progress.unshift({
          date: today,
          totalCount: 1,
          correctCount: correctResponse ? 1 : 0,
          sessions: 0,
          time: Math.round(question.time / 1000)
        });
      } else {
        if (!stats.progress.length) {
          stats.progress[0] = {
            date: today,
            totalCount: 0,
            correctCount: 0,
            time: 0
          };
        }

        if (!stats.quizzes.length) {
          stats.quizzes[0] = {
            totalCount: 0,
            correctCount: 0,
            time: 0
          };
        }
        Object.assign(stats.progress[0], {
          totalCount: stats.progress[0].totalCount + 1,
          correctCount: correctResponse
            ? stats.progress[0].correctCount + 1
            : stats.progress[0].correctCount,
          time: stats.progress[0].time + Math.round(question.time / 1000)
        });
        Object.assign(stats.quizzes[0], {
          totalCount: stats.quizzes[0].totalCount + 1,
          correctCount: correctResponse
            ? stats.quizzes[0].correctCount + 1
            : stats.quizzes[0].correctCount,
          time: stats.quizzes[0].time + Math.round(question.time / 1000)
        });
        if (stats.quizzes.length < 2) {
          stats.quizzes[1] = {
            totalCount: 0,
            correctCount: 0,
            time: 0
          };
        }
      }

      Object.assign(stats.overall, {
        totalCount: stats.overall.totalCount + 1,
        correctCount: correctResponse
          ? stats.overall.correctCount + 1
          : stats.overall.correctCount,
        time: stats.overall.time + Math.round(question.time / 1000)
      });
    }
    dispatch({
      type: ACTIONS.TYPES.APP.FETCH_STATS_SUCCESS,
      stats
    });
  };
}

export function fetchNotesFlagged() {
  return (dispatch, getState) => {
    dispatch({
      type: ACTIONS.TYPES.APP.FETCH_FILTERED_SUCCESS,
      filtered: {
        notes: [],
        flagged: [],
        loading: true
      }
    });
    return ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
      `${ACTIONS.JSON_API_PATH}/_notesFlags`,
      {
        headers: {
          Authorization: `Bearer ${
            process.env.REACT_APP_MOBILE_TEST
              ? 'MOBILE_TEST_AUTH'
              : getState().auth.accessToken
          }`
        },
        params: { product: getState().app.product }
      }
    ).then(res =>
      dispatch({
        type: ACTIONS.TYPES.APP.FETCH_FILTERED_SUCCESS,
        filtered: {
          notes: res.data.data[0].attributes.notes.map(n =>
            Object.assign(n, { editingNotes: true })
          ),
          flagged: res.data.data[0].attributes.flagged,
          loading: false
        }
      })
    );
  };
}

export function fetchHistory(isInit) {
  if (isInit) {
    return (dispatch, getState) => {
      dispatch({
        type: ACTIONS.TYPES.APP.FETCH_FILTERED_SUCCESS,
        history: {
          loading: true
        }
      });
      return Promise.all([
        ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
          `${ACTIONS.JSON_API_PATH}/_notesFlags`,
          {
            headers: {
              Authorization: `Bearer ${
                process.env.REACT_APP_MOBILE_TEST
                  ? 'MOBILE_TEST_AUTH'
                  : getState().auth.accessToken
              }`
            },
            params: { product: getState().app.product }
          }
        ),
        ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
          `${ACTIONS.JSON_API_PATH}/_quizHistory`,
          {
            headers: {
              Authorization: `Bearer ${
                process.env.REACT_APP_MOBILE_TEST
                  ? 'MOBILE_TEST_AUTH'
                  : getState().auth.accessToken
              }`
            },
            params: { product: getState().app.product }
          }
        )
      ]).then(res =>
        dispatch({
          type: ACTIONS.TYPES.APP.FETCH_FILTERED_SUCCESS,
          history: Object.assign(_.cloneDeep(getState().filtered) || {}, {
            notes: res[0].data.data[0].attributes.notes.map(n =>
              Object.assign(n, { editingNotes: true })
            ),
            bookmarks: res[0].data.data[0].attributes.flagged,
            quizzes: res[1].data.data[0].attributes.quizzes
              .map(q =>
                Object.assign(q, {
                  correctCount: q.questions.reduce(
                    (num, q) =>
                      q.selectedOptionIndex !== null &&
                      q.options[q.selectedOptionIndex].correctOption
                        ? num + 1
                        : num,
                    0
                  )
                })
              )
              .map(quiz =>
                Object.assign(quiz, {
                  questions: quiz.questions.map(q =>
                    Object.assign(q, {
                      lastAttemptCorrect:
                        q.selectedOptionIndex !== null
                          ? q.options[q.selectedOptionIndex].correctOption
                          : false
                    })
                  )
                })
              ),
            isDirty: false,
            loading: false
          })
        })
      );
    };
  } else {
    return (dispatch, getState) => {
      return ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
        `${ACTIONS.JSON_API_PATH}/_notesFlags`,
        {
          headers: {
            Authorization: `Bearer ${
              process.env.REACT_APP_MOBILE_TEST
                ? 'MOBILE_TEST_AUTH'
                : getState().auth.accessToken
            }`
          },
          params: { product: getState().app.product }
        }
      ).then(res => {
        return dispatch({
          type: ACTIONS.TYPES.APP.FETCH_FILTERED_SUCCESS,
          history: Object.assign(_.cloneDeep(getState().filtered) || {}, {
            notes: res.data.data[0].attributes.notes.map(n =>
              Object.assign(n, { editingNotes: true })
            ),
            bookmarks: res.data.data[0].attributes.flagged,
            isDirty: false,
            loading: false
          })
        });
      });
    };
  }
}

export function setHistoryDirtyBit() {
  return (dispatch, getState) => {
    const history = _.cloneDeep(getState().filtered);
    dispatch({
      type: ACTIONS.TYPES.APP.FETCH_FILTERED_SUCCESS,
      history: Object.assign(history, { isDirty: true })
    });
  };
}

export function updateNotesFlagged(question, isNotes, value) {
  return (dispatch, getState) => {
    const state = getState();
    const history = _.cloneDeep(state.filtered);

    if (history) {
      if (history.loading === false) {
        if (isNotes) {
          const questionIndex = _.findIndex(
            history.notes,
            n => n.id === question.id
          );
          if (value !== '') {
            if (questionIndex >= 0) {
              history.notes[questionIndex].notes = value;
            } else {
              history.notes.push(Object.assign(question, { notes: value }));
            }
          }
        } else {
          const questionIndex = _.findIndex(
            history.bookmarks,
            n => n.id === question.id
          );
          if (value) {
            if (questionIndex < 0) {
              history.bookmarks.push(
                Object.assign(question, { bookmarks: value })
              );
            }
          } else {
            _.remove(history.bookmarks, q => q.id === question.id);
          }
        }
      }
      dispatch({ type: ACTIONS.TYPES.APP.FETCH_FILTERED_SUCCESS, history });
    }
  };
}

export function updateSettings(key, value, key2, val2) {
  return (dispatch, getState) => {
    const state = getState();
    const existingSettings = _.cloneDeep(state.app.settings);
    const settings = Object.assign(
      existingSettings ? existingSettings.values : {},
      { [key]: value },
      key2 && val2 ? { [key2]: val2 } : {}
    );
    const method = state.app.settings ? 'patch' : 'post';
    const accountId = state.app.user.id;
    return ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)
      [method](
        `${ACTIONS.JSON_API_PATH}/accountProductSetting${
          existingSettings ? `/${existingSettings.id}` : ''
        }`,
        {
          data: {
            type: 'accountProductSetting',
            attributes: {
              settings
            },
            relationships: {
              product: {
                data: {
                  type: 'product',
                  id: getState().app.product
                }
              },
              account: {
                data: {
                  type: 'account',
                  id: accountId
                }
              }
            }
          }
        },
        {
          headers: {
            Authorization: `Bearer ${
              process.env.REACT_APP_MOBILE_TEST
                ? 'MOBILE_TEST_AUTH'
                : getState().auth.accessToken
            }`
          }
        }
      )
      .then(data => {
        return new Promise(res => {
          const { id } = data.data.data;
          const app = Object.assign(_.cloneDeep(state.app), {
            settings: { id, values: settings }
          });
          res(dispatch({ type: ACTIONS.TYPES.APP.UPDATE_APP, app }));
        });
      });
  };
}

export function resetQuestions() {
  return (dispatch, getState) => {
    return ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
      `${ACTIONS.JSON_API_PATH}/_resetAll`,
      {
        headers: {
          Authorization: `Bearer ${
            process.env.REACT_APP_MOBILE_TEST
              ? 'MOBILE_TEST_AUTH'
              : getState().auth.accessToken
          }`
        }
      }
    );
  };
}

export function updateProfession(id) {
  return (dispatch, getState) => {
    const state = getState();
    const accountId = state.app.user.id;
    return ACTIONS.AXIOS(
      getState().auth ? getState().auth.expiresAt : null
    ).patch(
      `${ACTIONS.JSON_API_PATH}/account/${accountId}`,
      {
        data: {
          type: 'account',
          attributes: {},
          relationships: {
            profession: {
              data: {
                type: 'profession',
                id
              }
            }
          }
        }
      },
      {
        headers: {
          Authorization: `Bearer ${
            process.env.REACT_APP_MOBILE_TEST
              ? 'MOBILE_TEST_AUTH'
              : getState().auth.accessToken
          }`
        }
      }
    );
  };
}

export function updateDashboardCurrentQuiz() {
  return (dispatch, getState) => {
    const state = getState();
    const stats = _.cloneDeep(state.stats);
    const totalCount = state.quiz.questions.reduce(
      (acc, q) => (q.answered ? acc + 1 : acc),
      0
    );
    const correctCount = state.quiz.questions.reduce(
      (acc, q) =>
        q.options[q.selectedOptionIndex] &&
        q.options[q.selectedOptionIndex].correctOption
          ? acc + 1
          : acc,
      0
    );
    const time = Math.round(
      state.quiz.questions.reduce((acc, q) => acc + q.time, 0) / 1000
    );
    const date = new Date()
      .toString()
      .split(' ')
      .slice(0, 4)
      .join(' ');
    stats.quizzes[0] = stats.quizzes[0] || {};
    stats.quizzes[0] = { totalCount, correctCount, time, date };
    dispatch({
      type: ACTIONS.TYPES.APP.FETCH_STATS_SUCCESS,
      stats
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/app.js